type SortType = "ASC" | "DESC";

interface UseTableSortArgs {
  sortField?: string;
  sortType?: string;
  sortableColumns?: string[];
  setData: (
    key: string,
    value: string | undefined,
    key2?: string,
    value2?: string | undefined
  ) => void;
}

interface UseTableSortResult {
  sortField?: string;
  sortType?: SortType;
  sortableColumns?: string[];
  onSortChange: (nextSortField?: string, nextSortType?: SortType) => void;
}

export const useTableSort = ({
  sortField,
  sortType,
  sortableColumns,
  setData,
}: UseTableSortArgs): UseTableSortResult => {
  const normalizedSortType =
    sortType === "ASC" || sortType === "DESC" ? sortType : undefined;

  const onSortChange = (nextSortField?: string, nextSortType?: SortType) => {
    if (sortableColumns && nextSortField) {
      if (!sortableColumns.includes(nextSortField)) {
        return;
      }
    }
    setData("sortType", nextSortType, "sortField", nextSortField);
  };

  return {
    sortField,
    sortType: normalizedSortType,
    sortableColumns,
    onSortChange,
  };
};
